import { post$ } from 'services/api';
import { logError } from 'services/logger';
import { UAParser } from 'ua-parser-js';

export const track = async (event: string, meta: any) => {
  await post$('/analytics', { event, ...meta }).catch(error => logError(error, 'tracking error'))
};

export const page = async () => {
  await track('page', {
    path: window.location.pathname,
    referrer: document.referrer,
    href: window.location.href,
    page: window.location.hash,
  })
}

export const identify = async () => {
  const uaParser = new UAParser();
  const results = uaParser.getResult();
  await track('identify', {
    type: results.device.type,
    vendor: results.device.vendor,
    browser: results.browser.name,
    os: results.os.name,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
  })
}
